// Debounce function to limit frequency of function calls
export const debounce = (func: any, delay: number): any => {
  let timeoutId: any;
  return (...args: any[]): void => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};
